import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { useTranslation } from "../i18n";
import { PublicVideoThumbnail } from "./PublicVideoThumbnail";
import { useState } from "react";
import { toast } from "sonner";

interface VideoSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  videoId: number | null;
  filename: string | null;
  token: string;
  cartId: number;
  onAdded: () => void;
  addToCart: (videoId: number) => Promise<boolean> | void;
}

export function VideoSelectionDialog({
  open,
  onClose,
  videoId,
  filename,
  token,
  cartId,
  onAdded,
  addToCart,
}: VideoSelectionDialogProps) {
  const { t } = useTranslation();
  const [adding, setAdding] = useState(false);

  if (!videoId || !filename) return null;

  const handleAdd = async () => {
    if (adding) return;
    setAdding(true);
    try {
      await addToCart(videoId);
      toast.success(t.cart.cartUpdated + " " + filename);
      onAdded();
      onClose();
    } catch (e) {
      toast.error(t.downloads.downloadError + " " + filename);
    } finally {
      setAdding(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{filename}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="aspect-video bg-muted rounded-md overflow-hidden">
            <PublicVideoThumbnail videoId={videoId} token={token} alt={filename} className="w-full h-full object-cover" />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={onClose} disabled={adding}>{t.common.cancel}</Button>
            <Button onClick={handleAdd} disabled={adding}>{t.gallery.addToCartButton}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
